import { MAIN_REGION_ID } from "./useRegionToggle";

export const scrollPageToTop = () => {
  const appShellMain = document.getElementById(MAIN_REGION_ID);
  if (appShellMain) appShellMain.scrollTop = 0;
  window.scrollTo(0, 0);
};
